import type { Locale } from "@sakani/contracts";

const AR_CURRENCY: Record<string, string> = { MAD: "د.م.", MRU: "أوقية" };

/**
 * Minor units → display. Arabic is rendered by hand with Western digits and a comma: the locale default
 * ("1.000") reads as one-point-zero-zero-zero to a shopper, which on a price is a costly misreading.
 */
export function money(minor: number, currency: string, locale: Locale): string {
  const amount = minor / 100;
  const digits = minor % 100 === 0 ? 0 : 2;
  if (locale === "ar") return `${new Intl.NumberFormat("en-US", { maximumFractionDigits: digits }).format(amount)} ${AR_CURRENCY[currency] ?? currency}`;
  return new Intl.NumberFormat(locale === "en" ? "en-GB" : "fr-FR", { style: "currency", currency, maximumFractionDigits: digits }).format(amount);
}

export const today = () => new Date().toISOString().slice(0, 10);
export const addDays = (d: string, n: number) => new Date(Date.parse(d) + n * 86_400_000).toISOString().slice(0, 10);
